import lazyLoad from 'vue-lazyload';

export default lazyLoad;
